export const CALENDAR_FOLLOW_UP_CAP_REQUEST_COUNT = 1

export const QA_NAME_CALENDAR_FOLLOW_UP_CAP_COLLEAGUE =
  'calendarFollowUpCapColleague'
